import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';

class CalculationService {
  async calculate(data) {
    return BaseService.post(API_ENDPOINTS.CALCULATIONS.CREATE, data);
  }

  async getCalculationTypes(includeInactive = false) {
    const params = includeInactive ? { includeInactive: 'true' } : {};
    return BaseService.get(API_ENDPOINTS.CALCULATIONS.TYPES, params, { useCache: false });
  }

  async getHistory(params = {}) {
    return BaseService.get(API_ENDPOINTS.CALCULATIONS.HISTORY, params);
  }

  async getCalculationById(id) {
    return BaseService.get(API_ENDPOINTS.CALCULATIONS.BY_ID(id));
  }

  async updateCalculation(id, data) {
    return BaseService.put(API_ENDPOINTS.CALCULATIONS.UPDATE(id), data);
  }

  async deleteCalculation(id) {
    return BaseService.delete(API_ENDPOINTS.CALCULATIONS.DELETE(id));
  }

  async toggleBookmark(id) {
    return BaseService.post(API_ENDPOINTS.CALCULATIONS.BOOKMARK(id));
  }

  async shareCalculation(id, data) {
    return BaseService.post(API_ENDPOINTS.CALCULATIONS.SHARE(id), data);
  }

  async getStatistics() {
    return BaseService.get(API_ENDPOINTS.CALCULATIONS.STATISTICS);
  }

  // ============= CALCULATION TYPES CRUD =============
  async createCalculationType(formData) {
    return BaseService.postFormData('/calculations/types', formData);
  }

  async updateCalculationType(formData) {
    // Backend expects: PUT /calculations/types with "key" parameter in FormData (REQUIRED)
    // key parameter identifies which calculation type to update
    return BaseService.putFormData('/calculations/types', formData);
  }

  async deleteCalculationType(key) {
    // Backend expects: DELETE /calculations/types with JSON body containing "key"
    return BaseService.delete('/calculations/types', { body: { key } });
  }

  // ============= CHOOSE TYPES CRUD =============
  async getChooseTypes(type, includeInactive = false) {
    const params = includeInactive ? { includeInactive: 'true' } : {};
    return BaseService.get(`/calculations/${type}/choose-types`, params);
  }

  async createChooseType(type, formData) {
    const endpoint = `/calculations/${type}/choose-types`;
    console.log('CalculationService.createChooseType - Endpoint:', endpoint);
    console.log('CalculationService.createChooseType - Type param:', type);
    console.log('CalculationService.createChooseType - This should create CHOOSE TYPE, NOT calculation type');
    return BaseService.postFormData(endpoint, formData);
  }

  async updateChooseType(type, formData) {
    return BaseService.putFormData(`/calculations/${type}/choose-types`, formData);
  }

  async deleteChooseType(type, key) {
    // Backend expects: DELETE with JSON body containing "key"
    return BaseService.delete(`/calculations/${type}/choose-types`, { body: { key } });
  }

  // ============= CHOOSE MATERIALS CRUD =============
  async getChooseMaterials(type, includeInactive = false) {
    const params = includeInactive ? { includeInactive: 'true' } : {};
    return BaseService.get(`/calculations/${type}/choose-materials`, params);
  }

  async createChooseMaterial(type, formData) {
    return BaseService.postFormData(`/calculations/${type}/choose-materials`, formData);
  }

  async updateChooseMaterial(type, formData) {
    return BaseService.putFormData(`/calculations/${type}/choose-materials`, formData);
  }

  async deleteChooseMaterial(type, key) {
    // Backend expects: DELETE with JSON body containing "key"
    return BaseService.delete(`/calculations/${type}/choose-materials`, { body: { key } });
  }

  // ============= INGREDIENTS CRUD =============
  async getIngredients(type, params = {}) {
    return BaseService.get(`/calculations/${type}/ingredients`, params);
  }

  async createIngredient(type, data) {
    return BaseService.post(`/calculations/${type}/ingredients`, data);
  }

  async updateIngredient(type, ingredientId, data) {
    if (ingredientId) {
      return BaseService.put(`/calculations/${type}/ingredients/${ingredientId}`, data);
    }
    return BaseService.put(`/calculations/${type}/ingredients`, data);
  }

  async deleteIngredient(type, { ingredientId, name }) {
    // materialId is no longer needed - calculation type's material is used automatically
    if (ingredientId) {
      return BaseService.delete(`/calculations/${type}/ingredients/${ingredientId}`);
    }
    return BaseService.delete(`/calculations/${type}/ingredients`, {
      body: { name }
    });
  }

  // ============= THICKNESS CRUD =============
  async getThickness(type, includeInactive = false) {
    const params = includeInactive ? { includeInactive: 'true' } : {};
    return BaseService.get(`/calculations/${type}/thickness`, params);
  }

  async createThickness(type, formData) {
    return BaseService.postFormData(`/calculations/${type}/thickness`, formData);
  }

  async updateThickness(type, formData) {
    return BaseService.putFormData(`/calculations/${type}/thickness`, formData);
  }

  async deleteThickness(type, key) {
    // Backend expects: DELETE with JSON body containing "key"
    return BaseService.delete(`/calculations/${type}/thickness`, { body: { key } });
  }

  // ============= CHOOSE SHAPES CRUD =============
  async getChooseShapes(type, includeInactive = false) {
    const params = includeInactive ? { includeInactive: 'true' } : {};
    return BaseService.get(`/calculations/${type}/choose-shapes`, params);
  }

  async getChooseShapeById(type, id) {
    return BaseService.get(`/calculations/${type}/choose-shapes/${id}`);
  }

  async createChooseShape(type, formData) {
    return BaseService.postFormData(`/calculations/${type}/choose-shapes`, formData);
  }

  async updateChooseShape(type, formData) {
    // Update by key - formData should contain "key" field
    return BaseService.putFormData(`/calculations/${type}/choose-shapes`, formData);
  }

  async updateChooseShapeById(type, id, formData) {
    // Update by ID
    return BaseService.putFormData(`/calculations/${type}/choose-shapes/${id}`, formData);
  }

  async deleteChooseShape(type, key) {
    // Delete by key - Backend expects: DELETE with JSON body containing "key"
    return BaseService.delete(`/calculations/${type}/choose-shapes`, { body: { key } });
  }

  async deleteChooseShapeById(type, id) {
    // Delete by ID
    return BaseService.delete(`/calculations/${type}/choose-shapes/${id}`);
  }
}

export default new CalculationService();
